import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppUrls } from '../app-urls';
import { Location } from '@angular/common';
import { ParticipantInfo } from 'src/app/generated/participant/participant-info';
import { ConfigurationService } from './configuration.service';
import { UserInfo } from '../../generated/configuration/user-info';

/** Сервис авторизации */
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly window: IWindow = <any>window;
  private readonly http: HttpClient;
  private authTokenUrl: string = AppUrls.auth.renewParticipantSecurityTokenUrl;
  private authSupplierTokenUrl: string = AppUrls.auth.renewParticipantSecurityTokenUrl;
  private authCustomerTokenUrl: string = AppUrls.auth.renewCustomerSecurityTokenUrl;

  constructor(
    private backend: HttpBackend,
    private location: Location,
    private _config: ConfigurationService,
  ) {
    // Отключаем все добавленные интерсепторы
    this.http = new HttpClient(backend);
  }

  /**
   * Выполняет выход из системы
   * @param returnUrl - ссылка для возврата.
   */
  public signOut(returnUrl: string = null, userInfo: ParticipantInfo | UserInfo): void {
    if (!returnUrl) {
      returnUrl = window.location.href;
    }

    const baseUrl = environment.urls.fcsBaseUrl;
    const logOutUrl = userInfo?.isCustomer
      ? AppUrls.auth.customerLogOutUrl
      : AppUrls.auth.participantLogOutUrl;
    const absoluteLogoutUrl = `${baseUrl}${logOutUrl}`;

    window.location.href = `${absoluteLogoutUrl}?returnUrl=${returnUrl}`;
  }

  /**
   * Выполняет редирект на страницу авторизации
   * @param returnUrl - ссылка для возврата.
   */
  public redirectToAuthPage(returnUrl: string = null): void {
    if (!returnUrl) {
      returnUrl = window.location.href;
    }

    const currentPath = this.location.path();
    const customerPathRegex = /^\/customer{1}/;
    const isCustomerPath = customerPathRegex.test(currentPath);

    const baseUrl = environment.urls.fcsBaseUrl;
    const logInUrl = isCustomerPath
      ? AppUrls.auth.customerLogInUrl
      : AppUrls.auth.logInUrl;
    const absoluteLoginUrl = `${baseUrl}${logInUrl}`;

    window.open(`${absoluteLoginUrl}?returnUrl=${encodeURIComponent(returnUrl)}`, '_self');
  }

  /**
   * Парсит текущий урл для определения кого мы будем авторизовывать, поставщика или заказчика
   * @param location - текущий адрес пользователя
   */
  public parseLocation(location) {
    const pathname = location._locationStrategy._platformLocation.pathname as string;
    const regexp = /^\/customer{1}/;
    if (regexp.test(pathname)) {
      this.authTokenUrl = this.authCustomerTokenUrl;
    } else {
      this.authTokenUrl = this.authSupplierTokenUrl;
    }
  }

  /** Выполняет обновление токена безопасности - продлевает сессию. */
  public async renewSecurityToken(): Promise<void> {
    this.parseLocation(this.location);

    const baseUrl = this._config.configuration.links.fcsBaseUrl;
    const fullRenewUrl = `${baseUrl}${this.authTokenUrl}`;

    try {
      await this.http
        .get(fullRenewUrl, {
          withCredentials: true,
        })
        .toPromise();
    } catch (error) {
      console.error('Не удалось продлить токен безопасности', error);
    }
  }
}
